import moment from 'moment'

export const toDateWithYear = value => (
  moment(value).format('DD/MM/YYYY')
)
export const toDateWithYearFirst = value => (
  moment(value).format('YYYY-MM-DD')
)

export const toDateWithUnderscore = value => (
  moment(value).format('YYYY_MM_DD')
)
export const customDate = value => (
  moment(value).format('DD/MMM/YYYY')
)
export const tocustomDate = value => (
  moment(value).format('DD-MMM-YYYY')
)
export const toDateYear = value => (
  moment(value).format('DD-MM-YYYY')
)
export const toDateTime = value => (
  moment(value).format('DD/MMM/YYYY h:mm:ss A')
)

export const toDateTimeFormat = value => (
  moment(value).format('DD MMM, YYYY h:mm:ss a')
)
export const toDateWithTime = selectedDate => (
  moment.utc(selectedDate).format('DD/MM/YYYY h:mm:ss a')
)
export const toDateWithTimes = selectedDate => (
  moment(selectedDate).format('DD/MM/YYYY h:mm A')
)
export const toDateWithCustomTime = selectedDate => (
  moment(selectedDate).format('DD/MM/YYYY h:mm:ss A')
)
export const toYearWithDateTime = selectedDate => (
  moment(selectedDate).format('YYYY-MM-DD h:mm:ss a')
)
export const toDateWithDateTime = selectedDate => (
  moment(selectedDate).format('YYYY-MM-DD h:mm:ss A')
)

export const toCustomDateTime = dateValue => (
  moment(dateValue).format('Do MMM YYYY h:mm:ss A')
)
export const toCustomDate = dateValue => (
  moment(dateValue).format('Do MMM YYYY')
)
export const toDayMonthYear = dateValue => (
  moment(dateValue).format('DD MMM, YYYY')
)
export const toMonthYear = dateValue => {
  const check = moment(dateValue, 'DD/MM/YYYY')
  const month = check.format('MMM')
  const year = check.format('YYYY')
  return month + year
}
export const toDateWithMinute = selectedDate => (
  moment(selectedDate).format('DD/MM/YYYY h:mm a')
)

export const toYearWithDate = selectedDate => {
  if (selectedDate !== null) {
    const splittedDate = selectedDate.split('/')
    const commencementDate = new Date(+splittedDate[2], splittedDate[1] - 1, +splittedDate[0])
    return moment(commencementDate).format('YYYY-MM-DD')
  }
  return ''
}

export const toDateWithMonth = selectedDate => {
  if (selectedDate !== null) {
    const splittedDate = selectedDate.split('-')
    return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
  }
  return ''
}
export const checkDateFormat = dateValue => {
  // eslint-disable-next-line eqeqeq
  if (new Date(dateValue) == 'Invalid Date') {
    const splitDate = dateValue.split(' ')[0]
    const splittedDate = splitDate.split('-')
    return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
  }
  return dateValue
}
export const dateSpecial = dateValue => {
  const dateParts = dateValue.split(' ')
  const date = dateParts[0].split('-')
  return `${date[0]}/${date[1]}/${date[2]}`
}

export const dateDifference = (startDate, endDate) => {
  const start = moment(startDate)
  const end = moment(endDate)
  return end.diff(start, 'days')
}

export const dateTimeDifference = (startDate, endDate) => {
  const diffTime = Math.abs(new Date(endDate).valueOf() - new Date(startDate).valueOf())
  const days = diffTime / (24 * 60 * 60 * 1000)
  const hours = (days % 1) * 24
  const minutes = (hours % 1) * 60
  const secs = ((minutes % 1) * 60) < 1 ? 1 : ((minutes % 1) * 60)
  const [hour, minute, sec] = [Math.floor(hours), Math.floor(minutes), Math.floor(secs)]
  return `${hour}h : ${minute}m : ${sec}s`
}

export const toMonthWithTime = selectedDate => (
  moment(selectedDate).format('MMM Do YYYY, h:mm:ss a')
)
export const toMonthWithYear = selectedDate => (
  moment(selectedDate).format('MMM Do, YYYY')
)

export const toMonthWithYearTime = selectedDate => {
  if (selectedDate !== null) {
    const splittedDate = selectedDate.split('/')
    const commencementDate = new Date(+splittedDate[2], splittedDate[1] - 1, +splittedDate[0])
    return moment(commencementDate).format('MMM DD YYYY, h:mm:ss A')
  }
  return ''
}

export const getDate = (date, numOfDays = 1) => {
  const endDate = new Date(date)
  endDate.setDate(endDate.getDate() - Number(numOfDays))
  return moment(endDate).format('DD/MM/YYYY')
}
export const getMinusOneDayDate = (date, numOfDays = 1) => {
  const endDate = new Date(date)
  endDate.setDate(endDate.getDate() - Number(numOfDays))
  return moment(endDate).format('YYYY-MM-DD')
}
export const getDaysInMonth = frequency => {
  if (frequency === 'Month') {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth() + 1
    const daysInMonth = [31, (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    return daysInMonth[month - 1]
  }
  return ''
}
export const getDaysInYear = frequency => {
  if (frequency === 'Year') {
    const today = new Date()
    const year = today.getFullYear()
    return (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 366 : 365
  }
  return ''
}

export const formatSingleDates = (day, month, year) => {
  const inputDateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  const inputDate = new Date(inputDateStr)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  if (inputDate > today) {
    return 'Invalid Date, The selected Date cannot be in the future.'
  }
  return inputDateStr
}

export const convertDateString = dateString => {
  const dateObj = new Date(dateString)
  const year = dateObj.getFullYear()
  const month = dateObj.getMonth() + 1
  const day = dateObj.getDate()

  return { year, month, day }
}
export const convertDate = dateString => {
  const dateObj = new Date(dateString)
  const operationYear = dateObj.getFullYear()
  const operationMonth = dateObj.getMonth() + 1
  const operationDay = dateObj.getDate()

  return { operationYear, operationMonth, operationDay }
}

export const isLeapYear = year => (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)

export const convertDateFormat = dateString => {
  // Return null for invalid inputs
  if (!dateString || typeof dateString !== 'string') {
    return null
  }

  // Regular expression to validate YYYY-MM-DD format
  // Matches: YYYY-MM-DD where YYYY is 1000-9999, MM is 01-12, DD is 01-31
  const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/
  const match = dateString.match(dateRegex)

  if (!match) {
    return null // Invalid format
  }

  const year = parseInt(match[1], 10)
  const month = parseInt(match[2], 10)
  const day = parseInt(match[3], 10)

  // Validate date ranges
  if (year < 1000 || year > 9999) {
    return null // Invalid year
  }

  if (month < 1 || month > 12) {
    return null // Invalid month
  }

  // Check days per month (including leap year February)
  const daysInMonth = [0, 31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  if (day < 1 || day > daysInMonth[month]) {
    return null // Invalid day for this month
  }

  // Format with leading zeros
  return {
    day: day.toString().padStart(2, '0'),
    month: month.toString().padStart(2, '0'),
    year,
  }
}

export const calculateDurationString = dateStr => {
  // Check if a date string was actually provided
  if (!dateStr) {
    return ''
  }

  try {
    const selectedDate = moment(dateStr, 'DD/MM/YYYY')

    // Get the current date using moment
    const today = moment()

    // Check if the selected date is valid and not in the future
    if (!selectedDate.isValid()) {
      console.warn('Invalid date provided for duration calculation:', dateStr)
      return 'Invalid Date'
    }
    if (selectedDate.isAfter(today)) {
      console.warn('Future date provided for duration calculation:', dateStr)
      return 'Future Date'
    }

    // Calculate the difference in full years
    const yearsDifference = today.diff(selectedDate, 'years')

    let durationString = ''

    if (yearsDifference >= 1) {
      // If one year or more, calculate and show years and remaining days

      // Create a date yearsDifference years after the selectedDate
      const dateAfterYears = moment(selectedDate).add(yearsDifference, 'years')

      // Calculate the remaining difference in days between dateAfterYears and today
      const remainingDays = today.diff(dateAfterYears, 'days')

      // Build the years part of the string, handling pluralization
      const yearsString = `${yearsDifference} year${yearsDifference > 1 ? 's' : ''}`

      if (remainingDays > 0) {
        // Build the days part of the string if there are remaining days, handling pluralization
        const daysString = `${remainingDays} day${remainingDays !== 1 ? 's' : ''}`
        // Combine years and days
        durationString = `${yearsString} ${daysString}`
      } else {
        // Exactly on a year boundary (0 remaining days) - show only years
        durationString = yearsString
      }
    } else {
      // If less than one full year, calculate difference in days
      const daysDifference = today.diff(selectedDate, 'days')
      // This case should only happen if daysDifference is >= 0 due to the future date check above
      durationString = `${daysDifference} day${daysDifference !== 1 ? 's' : ''}`
    }

    return durationString
  } catch (error) {
    console.error('Error calculating duration:', error)
    return 'Error' // Indicate error
  }
}

export const formatDateToISO = dateStr => {
  const [day, month, year] = dateStr.split('-')

  if (!day || !month || !year || day.length !== 2 || month.length !== 2 || year.length !== 4) {
    return 'Invalid format'
  }

  const isoDate = `${year}-${month}-${day}`
  const dateObj = new Date(isoDate)

  if (Number.isNaN(dateObj.getTime())) {
    return 'Invalid date'
  }

  return isoDate
}
